import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import FacturaForm from './FacturaForm.jsx';
import Input from './Input.jsx';
import Paper from 'material-ui/Paper';
import Toggle from 'material-ui/Toggle';
import Add from 'material-ui/svg-icons/content/add';
import validate from 'validator';
import moment from 'moment';

class RetIvaForm extends Component {

    formatDate(fecha) {
        let day = fecha.getUTCDate() < 10 ? '0' + fecha.getUTCDate() : fecha.getUTCDate(),
            month = (fecha.getUTCMonth() + 1) < 10 ? '0' + (fecha.getUTCMonth() + 1) : fecha.getUTCMonth() + 1,
            year = fecha.getUTCFullYear();

        return moment(fecha).format('DD-MM-YYYY');
    }

    render() {
        let facturas = this.props.retiva.facturas.map(
            (item, index) =>
            <FacturaForm
                key={index}
                line={index+1}
                factura={item}
                handleInputChange={this.props.handleInputChange}
                handleQuitarFactura={this.props.handleQuitarFactura}
                />
        );

        //If the are 5 facturas already do not show the AgregarButton
        let AgregarButton = null;

        let sendable = false,
            sendLabel = 'Debe agregar un email al proveedor para enviar por correo';

        if (validate.isEmail(this.props.mail)) {
            sendable = true;
            sendLabel = 'Enviar por email';
        }

        if (this.props.retiva.facturas.length <= 4)
        AgregarButton = (
            <RaisedButton
                    icon={<Add/>}
                    label="Agregar Linea"
                    style={{marginTop:5}}
                    onTouchTap={this.props.handleAgregarFactura}
                    secondary={true} />
        );

        return (
            <form>
            <Paper style={{padding: '0px 20px 20px 20px', margin: '10px 0px'}}>
                <div className="row">

                    <div className="col-xs-7">
                        <Input
                        validations="required,number"
                        disabled={false}
                        val={this.props.retiva.numeroRet}
                        editVal={this.props.retiva.numero}
                        onBlurs={this.props.handleRetIvaInputChange}
                        name="numero"
                        floatingLabelText="Nro. Retención"
                        fullWidth={true}
                        debounce={0} />
                    </div>

                    <div className="col-xs-5">
                        <Input
                        name="fecha"
                        validations="required"
                        date={true}
                        locale={navigator.language}
                        DateTimeFormat={Intl.DateTimeFormat}
                        formatDate={this.formatDate}
                        onChange={this.props.handleDateChange}
                        val={this.props.retiva.fecha}
                        floatingLabelText="Fecha"
                        fullWidth={true}
                        floatingLabelStyle={{zIndex:0}} />
                    </div>

                    <div class="col-xs-12">
                        <Toggle
                          labelPosition="right"
                          defaultToggled={false}
                          disabled={!sendable}
                          toggled={this.props.sendMail}
                          onToggle={this.props.toggleMail}
                          label={sendLabel}
                          style={{margin:'12px 0px 0px 8px'}}
                        />
                    </div>

                </div>
                </Paper>

                {facturas}

                {AgregarButton}

            </form>
        );
    }
}

export default RetIvaForm;



/** WEBPACK FOOTER **
 ** ./app-react/components/Forms/RetIvaForm.jsx
 **/